import { threeUtils } from './ThreeUtils';
import { Box3, Vector3 } from 'three';
export class FakeBoundingBoxService {
    constructor(boundingBox, boundary) {
        this.boundingBox = boundingBox;
        this.boundary = boundary;
    }
    getBoundingBox(_root) {
        return this.boundingBox;
    }
    getBoundingBoxProjection(_boundingBox, _camera, _screenSize) {
        return this.boundary;
    }
}
export class BoundingBoxService {
    getBoundingBox(root) {
        const bbox = new Box3();
        bbox.setFromObject(root);
        const size = new Vector3();
        bbox.getSize(size);
        return bbox;
    }
    getBoundingBoxProjection(bbox, camera, screenSize) {
        const center = new Vector3();
        bbox.getCenter(center);
        const size = new Vector3();
        bbox.getSize(size);
        const vertexes = [
            new Vector3(-0.5 * size.x + center.x, -0.5 * size.y + center.y, -0.5 * size.z + center.z),
            new Vector3(-0.5 * size.x + center.x, -0.5 * size.y + center.y, 0.5 * size.z + center.z),
            new Vector3(-0.5 * size.x + center.x, 0.5 * size.y + center.y, -0.5 * size.z + center.z),
            new Vector3(-0.5 * size.x + center.x, 0.5 * size.y + center.y, 0.5 * size.z + center.z),
            new Vector3(0.5 * size.x + center.x, -0.5 * size.y + center.y, -0.5 * size.z + center.z),
            new Vector3(0.5 * size.x + center.x, -0.5 * size.y + center.y, 0.5 * size.z + center.z),
            new Vector3(0.5 * size.x + center.x, 0.5 * size.y + center.y, -0.5 * size.z + center.z),
            new Vector3(0.5 * size.x + center.x, 0.5 * size.y + center.y, 0.5 * size.z + center.z),
        ].map((v) => threeUtils.get2DPosition(v, camera, screenSize.width, screenSize.height));
        return vertexes.reduce((acc, next) => ({
            minX: Math.min(acc.minX, next.x),
            minY: Math.min(acc.minY, next.y),
            maxX: Math.max(acc.maxX, next.x),
            maxY: Math.max(acc.maxY, next.y),
        }), { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity });
    }
}
//# sourceMappingURL=BoundingBoxService.js.map